// ブラウザの履歴に新しいURLを登録する。pushStateの引数の説明は以下のリンクで確認できる。
// https://developer.mozilla.org/ja/docs/Web/API/History/pushState
const pushNewUrlToHistory = (url?: string, state?: object) => {
  // 第1引数(state): ブラウザの「戻る」と「進む」ボタンを押下した際に、popstateイベントが発火する。その際にここで設定するstateが、event.stateから取得できる。
  // 第2引数(title): 画面のタイトルを設定する。公式ドキュメントによると、この引数は大抵のブラウザに無視され、画面タイトルを設定するには、document.titleで設定するとされている。
  // 第3引数(url): ブラウザのアドレス欄に表示する新しいURL。
  window.history.pushState(state, '', url);
};
const replaceNewUrlToHistory = (url?: string, state?: object) => {
  // 第1引数(state): ブラウザの「戻る」と「進む」ボタンを押下した際に、popstateイベントが発火する。その際にここで設定するstateが、event.stateから取得できる。
  // 第2引数(title): 画面のタイトルを設定する。公式ドキュメントによると、この引数は大抵のブラウザに無視され、画面タイトルを設定するには、document.titleで設定するとされている。
  // 第3引数(url): ブラウザのアドレス欄に表示する新しいURL。
  window.history.replaceState(state, '', url);
};

const isBrowserSupportsHistory = () => {
   // @ts-ignore pushStateはブラウザによっては存在するとは限らないため、pushStateの存在確認は必要。
  return window.history && window.history.pushState && window.history.replaceState;
};

const HistoryUtil = {
  pushNewUrlToHistory,
  replaceNewUrlToHistory,
  isBrowserSupportsHistory
};

export default HistoryUtil;
